export var createReadElementType = function (readVariableSizeInteger) {
    return function (dataView, offset) {
        var lengthAndValue = readVariableSizeInteger(dataView, offset);
        if (lengthAndValue === null) {
            return lengthAndValue;
        }
        var length = lengthAndValue.length, value = lengthAndValue.value;
        if (value === 35) {
            return { length: length, type: 'binary' };
        }
        if (value === 46 ||
            value === 97 ||
            value === 88713574 ||
            value === 106212971 ||
            value === 139690087 ||
            value === 172351395 ||
            value === 256095861) {
            return { length: length, type: 'master' };
        }
        return { length: length, type: 'unknown' };
    };
};
//# sourceMappingURL=read-element-type.js.map
